import React from "react";
import NewChatItem from "./NewChatItem";
import CustomScrollbars from "../../../util/CustomScrollbars";
import Auxiliary from "../../../util/Auxiliary";
import { useSelector } from "react-redux";

function RecentChatList({ setShowMenu }: any) {
  const fgChat = useSelector(({ fgChat }: any) => fgChat);

  return (
    <Auxiliary>
      <div className="gx-popover-header">
        <h3 className="gx-mb-0">پیام‌های خوانده نشده</h3>
        <i className="gx-icon-btn icon icon-charvlet-down" />
      </div>
      <CustomScrollbars className="gx-popover-scroll">
        <ul className="gx-sub-popover  gx-p-0">
          {fgChat.userRoomsDetailWithNewMessage.map(
            (item: any, index: number) => (
              <NewChatItem key={index} item={item} setShowMenu={setShowMenu} />
            )
          )}
        </ul>
      </CustomScrollbars>
    </Auxiliary>
  );
}

export default RecentChatList;
